import React, { useMemo } from "react";

/* ===============================
   HELPERS (UNCHANGED)
================================ */
const formatTime = (seconds = 0) => {
  const s = Math.max(0, seconds);
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, "0")}`;
};

const formatDate = (date) => {
  if (!date) return "--";
  return new Date(date).toLocaleDateString("en-GB");
};

const formatClockTime = (date) => {
  if (!date) return "--";
  return new Date(date).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

const VALID_STATUSES = ["pending", "paid", "expired", "completed"];
export default function Orders({
  orders = [],
  orderTimers = {},
  myChatId,
  onConfirmPayment,
  onBack,
}) {
  const sortedOrders = useMemo(() => {
    return orders
      .filter(
        (o) =>
          o &&
          typeof o.status === "string" &&
          VALID_STATUSES.includes(o.status)
      )
      .sort((a, b) => {
        const aActive = ["pending", "paid"].includes(a.status);
        const bActive = ["pending", "paid"].includes(b.status);

        if (aActive !== bActive) return aActive ? -1 : 1;
        return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
      });
  }, [orders]);

   return (
    <div className="flex h-full w-full flex-col bg-neutral-50 p-4 dark:bg-neutral-900">
      <div className="flex h-full w-full flex-col sm:mx-auto sm:w-full sm:max-w-2xl">
     {/* ================= HEADER ================= */}
          <div className="mb-4 flex items-center gap-3">
        <button
          onClick={onBack}
          className="flex items-center justify-center w-9 h-9 shrink-0 rounded-full text-neutral-700 dark:text-neutral-200 hover:bg-neutral-100 dark:hover:bg-neutral-800 active:opacity-60 touch-manipulation transition-colors"
          aria-label="Back"
        >
          <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
          </svg>
        </button>

        <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100">
          📦 My Orders
        </h3>
      </div>

      {/* ================= LIST ================= */}
      <div className="flex flex-1 flex-col gap-3 overflow-y-auto">
        {sortedOrders.length === 0 && (
          <div className="flex flex-1 items-center justify-center text-sm text-neutral-500">
            No orders yet
          </div>
        )}

        {sortedOrders.map((order) => {
          const isSeller = order.sellerChatId === myChatId;
          const remaining = orderTimers?.[order.orderId];

          const hasTimer =
            ["pending", "paid"].includes(order.status) &&
            typeof remaining === "number" &&
            remaining > 0;

          const statusColor = {
            pending: "text-yellow-600 bg-yellow-50 dark:bg-yellow-900/20",
            paid: "text-blue-600 bg-blue-50 dark:bg-blue-900/20",
            completed: "text-green-600 bg-green-50 dark:bg-green-900/20",
            expired: "text-red-600 bg-red-50 dark:bg-red-900/20",
          }[order.status];

          return (
            <div
              key={order.orderId}
              className="
                rounded-xl border border-neutral-200 bg-white p-4
                shadow-sm
                dark:border-neutral-700 dark:bg-neutral-800
              "
            >
              {/* ===== TOP ROW ===== */}
              <div className="mb-2 flex items-center justify-between">
                <span className="text-sm font-semibold text-neutral-800 dark:text-neutral-100">
                  {order.asset || "ASSET"}
                </span>

                <span
                  className={`
                    rounded-md px-2 py-0.5 text-xs font-semibold
                    ${statusColor}
                  `}
                >
                  {order.status.toUpperCase()}
                </span>
              </div>

              {/* ===== DETAILS ===== */}
              <div className="space-y-1 text-sm text-neutral-600 dark:text-neutral-300">
                <div className="flex justify-between">
                  <span>Order ID</span>
                  <span className="font-mono text-xs">
                    {order.orderId}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span>Amount</span>
                  <span className="font-semibold">
                    {order.amount}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span>Time</span>
                  <span>
                    {hasTimer
                      ? formatTime(remaining)
                      : formatClockTime(order.createdAt)}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span>Date</span>
                  <span>{formatDate(order.createdAt)}</span>
                </div>
              </div>

              {/* ===== SELLER ACTION ===== */}
              {isSeller && order.status === "paid" && (
                <button
                  onClick={() => onConfirmPayment(order)}
                  className="
                    mt-3 w-full rounded-lg
                    bg-green-600 px-4 py-2 text-sm font-semibold text-white
                    hover:bg-green-700
                  "
                >
                  ✅ confirm Payment
                </button>
              )}
            </div>
          );
               })}
      </div>
      </div>
    </div>
  );
}